import { Component, OnInit, AfterViewInit } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterEvent } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpinnerName } from 'src/app/core/models/spinners.model';
import { GlobalService } from 'src/app/core/services/global.service';

@Component({
  selector: 'app-horizontal',
  templateUrl: './horizontal.component.html',
  styleUrls: ['./horizontal.component.scss']
})

/**
 * Horizontal-layout component
 */
export class HorizontalComponent implements OnInit, AfterViewInit {
  readonly layoutSpinner: string = SpinnerName.LAYOUT

  constructor(private router: Router, private spinner: NgxSpinnerService, private readonly globalService: GlobalService) {
    router.events.subscribe( (event: RouterEvent) => {
      spinner.hide(SpinnerName.APP)
      if( event instanceof RouteConfigLoadStart ){
        spinner.show(this.layoutSpinner)
      }else if( event instanceof RouteConfigLoadEnd ){
        spinner.hide(this.layoutSpinner)
      }
    })
  }

  ngOnInit(): void {
    this.globalService.nativeDocument.body.setAttribute('data-layout', 'horizontal');
    this.globalService.nativeDocument.body.setAttribute('data-topbar', 'dark');
    this.globalService.nativeDocument.body.removeAttribute('data-sidebar');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-size');
    this.globalService.nativeDocument.body.removeAttribute('data-keep-enlarged');
    this.globalService.nativeDocument.body.removeAttribute('data-sidebar-small');
  }

  ngAfterViewInit(): void {
    this.globalService.nativeDocument.body.setAttribute("data-topbar", "light");
    this.globalService.nativeDocument.body.setAttribute("data-layout", "horizontal");
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked(): void {
    this.globalService.nativeDocument.body.classList.toggle('right-bar-enabled');
  }
}
